import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row container-fluid mt-2 d-flex w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Détails de la commande")
], -1)
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Payé :", -1)
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = {
  key: 1,
  class: ""
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Commande passer via :", -1)
const _hoisted_9 = {
  key: 0,
  class: ""
}
const _hoisted_10 = {
  key: 1,
  class: ""
}
const _hoisted_11 = {
  key: 2,
  class: ""
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Status:", -1)
const _hoisted_13 = { class: "" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Date de la commande:", -1)
const _hoisted_19 = { class: "" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "tx-11 fw-bolder mb-0 text-uppercase text-primary" }, "Planifier le:", -1)
const _hoisted_21 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["mb-2", [_ctx.order?.planified ? 'col-md-6' : 'col-md-4']])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.order?.is_paid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Oui"))
          : _createCommentVNode("", true),
        (!_ctx.order?.is_paid)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Non "))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mb-2", [_ctx.order?.planified ? 'col-md-6' : 'col-md-4']])
    }, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        (_ctx.order?.order_by == 'website' || _ctx.order?.order_by == 'website_perso')
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Site web"))
          : _createCommentVNode("", true),
        (_ctx.order?.order_by == 'manager')
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Manager"))
          : _createCommentVNode("", true),
        (_ctx.order?.order_by == 'borne')
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Borne"))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mb-2", [_ctx.order?.planified ? 'col-md-6' : 'col-md-4']])
    }, [
      _createElementVNode("div", null, [
        _hoisted_12,
        _createElementVNode("p", _hoisted_13, [
          (_ctx.order?.status == 'accepted')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " En préparation "))
            : _createCommentVNode("", true),
          (_ctx.order?.status == 'pending')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " En attente "))
            : _createCommentVNode("", true),
          (_ctx.order?.status == 'delivered')
            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Livrées "))
            : _createCommentVNode("", true),
          (_ctx.order?.status == 'canceled')
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Annulée "))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["mb-2", [_ctx.order?.planified ? 'col-md-6' : 'col-md-4']])
    }, [
      _createElementVNode("div", null, [
        _hoisted_18,
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.order?.created_at), 1)
      ])
    ], 2),
    (_ctx.order?.planified)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["mb-2", [_ctx.order?.planified ? 'col-md-6' : 'col-md-4']])
        }, [
          _createElementVNode("div", null, [
            _hoisted_20,
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.order?.planified_at), 1)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}